<div class="w80percent">
  <div class="fileUploadSection p-3">
    <p-fileUpload #createUploader name="demo[]" mode="basic" chooseLabel="Browse" [auto]="true" customUpload="true"
      (uploadHandler)="onUpload($event, createUploader)" accept=".txt, .doc, .docx, .pdf, .xls, .xlsx"
      showUploadButton="false" showCancelButton="false" [disabled]="!fileConfigurations.fdnsVisitId"
      maxFileSize="5000000">
    </p-fileUpload>
    <small>(Max file size is 10 MB | TXT, DOC, DOCX, PDF, XLS, and XLSX file types are allowed)</small>
  </div>
  <div *ngIf="uploadedDocuments.length > 0" class="mt-3">
    <h5 class="p-2">Uploaded Documents</h5>
    <div class="d-flex justify-content-center">


      <p-table [value]="uploadedDocuments" styleClass="fileUploadedDocumentsTable">
        <ng-template pTemplate="header">
          <!-- <tr>
                <th colspan="2">
            </tr> -->
          <tr>

            <th style="width: 9rem">Document Name</th>
            <th style="width: 2rem"><span>Action</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-doc>
          <tr>
            <td colspan="2" style="padding: 0!important;">
              <div class="col-9 d-inline-block fileNameBox">{{doc.fileName}} </div>

              <div class="col-3 d-inline-block">
                <!-- <span class="paddLft30px">
                            <button pButton type="button"
                                (click)="viewDocument(doc.filePath)"
                                class="p-button-icon-only bg-white border-0 text-secondary d-inline">
                                <mat-icon class="mr-1 icn" matTooltip="View Document"
                                    class="material-icons">visibility</mat-icon>

                            </button>
                        </span> -->
                <span class="paddLft30px downloadIconBox">
                  <app-file-download [fileName]="doc.filePath.substring(23)"
                    [Path]="envPath+doc.filePath.substring(23)"></app-file-download>
                </span>
                <span>
                  <button pButton type="button" (click)="confirmDelete(doc.id)"
                    class="p-button-icon-only bg-white border-0 text-secondary d-inline">
                    <mat-icon class="mr-1 icn" matTooltip="Delete Document" class="material-icons">delete</mat-icon>
                  </button>
                </span>


              </div>
            </td>
          </tr>

        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-confirmDialog header="Delete"></p-confirmDialog>
